import { render } from "./wechataccount.vue?vue&type=template&id=3efdc589&scoped=true"
import script from "./wechataccount.vue?vue&type=script&lang=js"
export * from "./wechataccount.vue?vue&type=script&lang=js"

import "./wechataccount.vue?vue&type=style&index=0&id=3efdc589&lang=scss&scoped=true"

import exportComponent from "/Users/tangyinbo/workspace/front/syb/syb_webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3efdc589"]])

export default __exports__